import {generatePath} from 'react-router-dom'

import routes from 'routes/pathConfig'
import {translatedUrl} from 'i18n/utils'

export const docSlugs = {
  whitepaper: 'whitepaper',
  imprint: 'imprint',
  privacyPolicy: 'privacy-policy',
  termsAndConditions: 'terms-and-conditions',
  userAgreement: 'user-agreement',
  userTermsAndConditions: 'users-terms-and-conditions',
  interconnectDoc: 'minebase-iwc',
  ctpBooster: 'incentive_booster',
}

export const docsOrder = [
  docSlugs.termsAndConditions,
  docSlugs.privacyPolicy,
  docSlugs.userAgreement,
]

export const getDocsInfo = t => ({
  [docSlugs.userAgreement]: {
    title: t('documents.userAgreement.title'),
    link: `${process.env.PUBLIC_URL}/documents/user-agreement.pdf`,
  },
  [docSlugs.whitepaper]: {
    title: t('documents.whitepaper.title'),
    link: `${process.env.PUBLIC_URL}/documents/v999-platform-white-paper.pdf`,
  },
  [docSlugs.imprint]: {
    title: t('documents.imprint.title'),
    link: `${process.env.PUBLIC_URL}/documents/v999-platform-imprint.pdf`,
  },
  [docSlugs.privacyPolicy]: {
    title: t('documents.privacyPolicy.title'),
    link: `${process.env.PUBLIC_URL}/documents/privacy-statement.pdf`,
  },
  [docSlugs.termsAndConditions]: {
    title: t('documents.termsAndConditions.title'),
    link: `${process.env.PUBLIC_URL}/documents/terms-and-conditions.pdf`,
  },
  [docSlugs.userTermsAndConditions]: {
    title: t('documents.termsAndConditions.title'),
    link: `${process.env.PUBLIC_URL}documents/users-terms-and-conditions.pdf`,
  },
  [docSlugs.interconnectDoc]: {
    title: t('documents.interconnectDoc.title'),
    link: `${process.env.PUBLIC_URL}documents/minebase-iwc.pdf`,
  },
  [docSlugs.ctpBooster]: {
    title: t('Incentive CTP Booster'),
    link: `${process.env.PUBLIC_URL}documents/incentive_booster.pdf`,
  },
})

export const getDocAppLink = (docSlug, route = routes.documents.singleDoc.path) =>
  translatedUrl(generatePath(route, {id: docSlug}))

export const getDocTitle = (slug, t) => getDocsInfo(t)[slug]?.title
export const getDocExternalLink = (slug, t) => getDocsInfo(t)[slug]?.link
